/**
 * @fileoverview
 * Implements the identify() method on jQuery objects. This is inspired by
 * Prototype's Element.identify() method.
 */

(function ($) {
    var idString = "jqIdentify";
    var globalCounter = 0;
    
    $.fn.identify = function () {
        if (this.attr("id") === "") {
            this.each(function () {
                id = idString + globalCounter++;
                $(this).attr("id", id);
            });
        }
        
        return this.attr("id");
    };
})(jQuery);